/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPromptProfiling extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPromptProfiling");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPromptProfiling.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPromptProfiling>): BackgroundJobPayloadForPromptProfiling {
        let obj = Object.assign(new BackgroundJobPayloadForPromptProfiling(), model);
        BackgroundJobPayloadForPromptProfiling.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPromptProfiling>): BackgroundJobPayloadForPromptProfiling {
        if (!model) return null;
        return BackgroundJobPayloadForPromptProfiling.newInstance(<BackgroundJobPayloadForPromptProfiling> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPromptProfiling) {
        if (!obj) return;

        models.BackgroundJobPayloadForPromptProfiling.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPromptProfiling): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPromptProfiling.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service account whose prompts to profile
     */
    service_account_id: string;

    /**
     * Optional: single prompt ID for on-demand recommendation
     */
    prompt_id: string;

}
